export const queryStringToObject = (query: string): Record<string, string> =>
  query
    .split('&')
    .filter((pair) => !!pair)
    .map((pair) => pair.split('=').map(decodeURIComponent))
    .reduce((prev, curr) => ({ ...prev, [curr[0]]: curr[1] }), {});
